import React, { PureComponent } from 'react';
import { CONNECTION_CATEGORY_DATABASE } from '../../../../constants/connectionCategories';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';

class DatabaseSourceConfiguration extends PureComponent {
  render() {
    return (
      <ConfigurationFields {...this.props} connectionCategory={CONNECTION_CATEGORY_DATABASE} />
    );
  }
}

export default DatabaseSourceConfiguration;
